import React from 'react';
import {render} from 'react-dom';

import Dialog from '../dialog/dialog.jsx';

class ModalManager {
    static closeAll () {
        if (window.__closeModalGroup && window.__closeModalGroup.length) {
            for (const run of window.__closeModalGroup) {
                if (run) {
                    run();
                }
            }
            window.__closeModalGroup = [];
        }
    }

    static pop() {
        if (window.__closeModalGroup && window.__closeModalGroup.length) {
            const run = window.__closeModalGroup.pop();
            if (run) {
                run();
            }
        }
    }
    /**
     * 弹出Modal方法
     * @param {any} modal 弹出的Modal
     * @param {any} options 额外参数
     * @param {string} id 可选参数，如果设置了，当页面中已经存在相同的id的时候，不再打开新的
     */
    static open (modal, options = {}, id) {
        const doc = window.document;
        if (id && doc.getElementById(`__modal${id}`)) {
            return;
        }
        const node = doc.createElement('div');
        node.id = id ? `__modal${id}` : `__modal${Date.now()}`;
        doc.body.appendChild(node);


        if (!options.onSubmit) {
            options.onSubmit = () => {
                //
            };
        }

        const ModalCpt = modal;

        render((
            <Dialog
                rootNodeRemove={() => {
                    doc.body.removeChild(node);
                }}
                {...options}
            >
                <ModalCpt />
            </Dialog>
        ), node);
    }
}

export default ModalManager;
